import { render, staticRenderFns } from "./generateQuestion.vue?vue&type=template&id=8e0f023a&scoped=true&"
import script from "./generateQuestion.vue?vue&type=script&lang=js&"
export * from "./generateQuestion.vue?vue&type=script&lang=js&"
import style0 from "./generateQuestion.vue?vue&type=style&index=0&id=8e0f023a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e0f023a",
  null
  
)

export default component.exports